import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Czy przechodził Pan(i) jakieś operacje? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "radio-button form-radio-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_5 = { class: "radio-button form-radio-button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_7 = { class: "error-message" }

import { useField } from 'vee-validate';
import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import OperationsDescriptionField from './OperationsDescriptionField.vue';
import OperationsYearsField from './OperationsYearsField.vue';
import OperationsComplicationsField from './OperationsComplicationsField.vue';


export default {
  __name: 'HasOperationsField',
  props: {
    isExtended: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;



const { value, errorMessage } = useField('hasOperations');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(RadioGroup), {
        class: "radio-group",
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_isRef(value) ? (value).value = $event : null))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(RadioGroupOption), {
            class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
            value: "yes"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  name: "hasOperations",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
                  type: "radio",
                  value: "yes"
                }, null, 512), [
                  [_vModelRadio, _unref(value)]
                ]),
                _hoisted_4,
                _createTextVNode(" Tak ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(RadioGroupOption), {
            class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
            value: "no"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  name: "hasOperations",
                  type: "radio",
                  value: "no",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null))
                }, null, 512), [
                  [_vModelRadio, _unref(value)]
                ]),
                _hoisted_6,
                _createTextVNode(" Nie ")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(errorMessage)), 1)
    ]),
    (_unref(value) === 'yes')
      ? (_openBlock(), _createBlock(OperationsDescriptionField, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'yes')
      ? (_openBlock(), _createBlock(OperationsYearsField, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'yes')
      ? (_openBlock(), _createBlock(OperationsComplicationsField, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}